import React, {ReactElement, SVGProps} from 'react'
import {Icon} from './Icon'

export function CircleCi(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <Icon {...props}>
      <path fill='#444'
            d='M11.951 16a3.806 3.806 0 013.807-3.807A3.817 3.817 0 0119.566 16a3.817 3.817 0 01-3.808 3.808A3.818 3.818 0 0111.951 16zm3.806-16C8.286 0 2.029 5.12.253 12.033c-.013.048-.013.093-.013.16 0 .417.336.768.767.768h6.447a.734.734 0 00.689-.444c1.329-2.88 4.24-4.896 7.616-4.896 4.621 0 8.381 3.76 8.381 8.383 0 4.627-3.76 8.387-8.387 8.387-3.373 0-6.285-2-7.613-4.897-.129-.253-.387-.448-.689-.448H1.007a.768.768 0 00-.767.768c0 .049.019.096.019.16 1.76 6.907 8.027 12.027 15.499 12.027 8.832 0 16-7.167 16-16 0-8.831-7.168-16-16-16z'/>
    </Icon>
  )
}
